import React, { useContext } from "react";
import SaveButton from "../SaveButton";
import TrackerModeSwitch from "../TrackerModeSwitch";
import { TrackerContext } from "../utils/types";
import { DescriptionAutocomplete } from "./DescriptionAutocomplete";
import { LiveTimer } from "./LiveTimer";
import { ManualTimeFields } from "./ManualTimeFields";
import { ProjectSelect } from "./ProjectSelect";

export const TrackerRow: React.FC = () => {
  const { isTracking, typeOfTracking, trackerLoading } =
    useContext(TrackerContext);

  return (
    <div
      style={{
        width: "100%",
        border: "1px solid #d9d9d9",
        borderRadius: 6,
        backgroundColor: "white",
        boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
        padding: "6px 8px",
        display: "flex",
        alignItems: "center",
      }}
    >
      {/* Description */}
      <DescriptionAutocomplete disabled={trackerLoading && isTracking} />

      {/* Project */}
      <ProjectSelect />

      {/* Time fields */}
      {typeOfTracking !== "Calendar" &&
        (typeOfTracking === "Manual" ? <ManualTimeFields /> : <LiveTimer />)}

      {/* Save / Start / Stop */}
      {typeOfTracking !== "Calendar" && (
        <div style={{ padding: "0 8px", flexShrink: 0 }}>
          <SaveButton />
        </div>
      )}

      {/* Mode switch */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          paddingRight: 6,
          flexShrink: 0,
        }}
      >
        <TrackerModeSwitch />
      </div>
    </div>
  );
};
